/**=========================================================
 * Module: config.js
 * App routes and resources configuration
 =========================================================*/

App.config(['$stateProvider','$urlRouterProvider', '$controllerProvider', '$compileProvider', '$filterProvider', '$provide', '$ocLazyLoadProvider', 'APP_REQUIRES',
  'RollbarProvider', 'IdleProvider', 'KeepaliveProvider', '$locationProvider',
function ($stateProvider, $urlRouterProvider, $controllerProvider, $compileProvider, $filterProvider, $provide, $ocLazyLoadProvider, appRequires, RollbarProvider,
  IdleProvider, KeepaliveProvider, $locationProvider) {
  'use strict';

  App.controller = $controllerProvider.register;
  App.directive  = $compileProvider.directive;
  App.filter     = $filterProvider.register;
  App.factory    = $provide.factory;
  App.service    = $provide.service;
  App.constant   = $provide.constant;
  App.value      = $provide.value;

  // LAZY MODULES
  // -----------------------------------

  $ocLazyLoadProvider.config({
    debug: false,
    events: true,
    modules: appRequires.modules
  });

  if(CONFIG.appVersion!='local' && CONFIG.appVersion!='test'){
    RollbarProvider.init({
      accessToken: "5526c4c0df6a4257ba61d7b522e1a103",
      captureUncaught: true,
      payload: {
        environment: CONFIG.appVersion
        ,person: {
          id: 0, // required 
          username: '',
          email: ''
        }
      }
    });
  }

  // configure Idle settings
  IdleProvider.idle(60*5); // in seconds
  IdleProvider.timeout(0); // in seconds
  KeepaliveProvider.interval(60*5); // in seconds


  // defaults to dashboard
  $urlRouterProvider.otherwise('/app/dashboard');

  //
  // Application Routes
  // -----------------------------------
  $stateProvider
    .state('app', {
        url: '/app',
        abstract: true,
        templateUrl: basepath('app.html'),
        controller: 'AppController',
        resolve: resolveFor('fastclick', 'modernizr', 'icons', 'screenfull', 'animo', 'sparklines', 'slimscroll', 'classyloader', 'toaster', 'csspiner', 'moment')
    })
    .state('section', {
        url: '/section',
        abstract: true,
        templateUrl: basepath('section.html'),
        controller: 'AppController',
        resolve: resolveFor('fastclick', 'modernizr', 'icons', 'screenfull', 'animo', 'sparklines', 'slimscroll', 'classyloader', 'toaster', 'csspiner', 'moment')
    })
    .state('section.page', {
      url: '/:page/:name',
      title: 'section',
      templateUrl: function ($stateParams){
        return basepath('sections/' + $stateParams.page.toLowerCase() + '.html' + (CONFIG && CONFIG.appVersion ? '?v=' + CONFIG.appVersion : ''));
      },
      controllerProvider: function($stateParams) {
        var ctrlName = $stateParams.page.charAt(0).toUpperCase() + $stateParams.page.slice(1).toLowerCase() + "Controller";
        return ctrlName;
      },
      resolve: resolveFor('ngDialog')
    })
    .state('page', {
        url: '/page',
        templateUrl: 'app/pages/page.html',
        resolve: resolveFor('modernizr', 'icons')
    })
    .state('page.login', {
        url: '/login?goTo&params',
        title: "Login",
        templateUrl: 'app/pages/login.html',
        controller: 'LoginController'
    })
    .state('page.recover', {
        url: '/recover',
        title: "Recover",
        templateUrl: 'app/pages/recover.html',
        controller: 'RecoverController'
    })
    .state('page.reset', {
        url: '/reset/:id/:reset',
        title: "Reset",
        templateUrl: 'app/pages/reset.html',
        controller: 'ResetController'
    })
    .state('page.enable', {
      url: '/enable/:id/:enable',
      title: "Enable",
      templateUrl: 'app/pages/enable.html',
      controller: 'EnableController'
  })
    .state('page.privacy', {
      url: '/privacy',
      title: "Privacy",
      templateUrl: 'app/pages/privacy.html',
      controller: 'PrivacyController'
    })
    .state('page.tm', {
      url: '/tm/:client',
      title: "TM",
      templateUrl: 'app/pages/tmupload.html',
      controller: 'TMUploadController',
      resolve: resolveFor('filestyle','bwizard','chosen','ngDialog','ngWig','flot-chart','moment')
    })
    .state('app.dashboard', {
        url: '/dashboard',
        title: 'Dashboard',
        templateUrl: basepath('dashboard.html'),
        controller: 'DashboardController',
        resolve: resolveFor('ngDialog')
    })
    .state('app.sdl', {
        url: '/sdl',
        title: 'sdl',
        templateUrl: basepath('sdl-instructions.html')
    })
    .state('app.do', {
        url: '/do/:action/:type/:filter',
        title: 'entity',
        templateUrl: function ($stateParams){
            return basepath('entities/' + $stateParams.type.toLowerCase() + '-open.html');
        },
        controllerProvider: function($stateParams) {
              var ctrlName = $stateParams.type.charAt(0).toUpperCase() + $stateParams.type.slice(1).toLowerCase() + "Controller";
              return ctrlName;
          },
          resolve: resolveFor('ngDialog')
    })
    .state('app.entity', {
        url: '/:action/:type/:filter',
        title: 'entity',
        templateUrl: function ($stateParams){
        	if(!$stateParams.type || !$stateParams.action){
        		$stateParams.type = 'projects';
        		$stateParams.action = 'list';
        	}
            return basepath('entities/' + $stateParams.type.toLowerCase() + '-' + $stateParams.action.toLowerCase() + '.html' + (CONFIG && CONFIG.appVersion ? '?v=' + CONFIG.appVersion : ''));
        },
        controllerProvider: function($stateParams) {
        	if(!$stateParams.type || !$stateParams.action){
        		$stateParams.type = 'projects';
        		$stateParams.action = 'list';
        	}
              var ctrlName = $stateParams.type.charAt(0).toUpperCase() + $stateParams.type.slice(1).toLowerCase() + "Controller";
              return ctrlName;
          },
        resolve: resolveFor('filestyle','bwizard','chosen','ngDialog','ngWig','ngJed','flot-chart')
    })
    ;


    // Set here the base of the relative path
    // for all app views
    function basepath(uri) {
      return 'app/views/' + uri;
    }

    // Generates a resolve object by passing script names
    // previously configured in constant.APP_REQUIRES
    function resolveFor() {
      var _args = arguments;
      return {
        deps: ['$ocLazyLoad','$q', function ($ocLL, $q) {
          // Creates a promise chain for each argument
          var promise = $q.when(1); // empty promise
          for(var i=0, len=_args.length; i < len; i ++){
            promise = andThen(_args[i]);
          }
          return promise;

          // creates promise to chain dynamically
          function andThen(_arg) {
            // also support a function that returns a promise
            if(typeof _arg == 'function')
                return promise.then(_arg);
            else
                return promise.then(function() {
                  // if is a module, pass the name. If not, pass the array
                  var whatToLoad = getRequired(_arg);
                  // simple error check
                  if(!whatToLoad) return $.error('Route resolve: Bad resource name [' + _arg + ']');
                  // finally, return a promise
                  return $ocLL.load( whatToLoad );
                });
          }
          // check and returns required data
          // analyze module items with the form [name: '', files: []]
          // and also simple array of script files (for not angular js)
          function getRequired(name) {
            if (appRequires.modules)
                for(var m in appRequires.modules)
                    if(appRequires.modules[m].name && appRequires.modules[m].name === name)
                        return appRequires.modules[m];
            return appRequires.scripts && appRequires.scripts[name];
          }

        }]};
    }

}]).config(['$locationProvider', function($locationProvider) {
    $locationProvider.hashPrefix('');
  
}]).config(['$translateProvider', function ($translateProvider) {
	$translateProvider.useLoader('$customStaticFilesLoader', {
        prefix : CONFIG.baseUrl + '/i18n/',
        suffix : ''
    });
    $translateProvider.registerAvailableLanguageKeys(['en_GB', 'it_IT', 'de_DE'], {
    'en': 'en_GB',
    'it': 'it_IT',
    'en_US': 'en_GB',
    'de': 'de_DE',
    'de_CH': 'de_DE'
  })
    $translateProvider.fallbackLanguage('en_GB');
    $translateProvider.determinePreferredLanguage();
    //$translateProvider.preferredLanguage('en_GB');
    //$translateProvider.useLocalStorage();
    
    $translateProvider.useSanitizeValueStrategy('escapeParameters');
}]).factory('$customStaticFilesLoader', [
    '$q',
    '$http',
    function ($q, $http) {
      return function (options) {
        if (!options || (!angular.isString(options.prefix) || !angular.isString(options.suffix))) {
          throw new Error('Couldn\'t load static files, no prefix or suffix specified!');
        }
        var deferred = $q.defer();
        var language = options.key.match(/^[a-z]{2}([-_][a-zA-Z]{2})?$/);
        if (language !== null && language[0] === options.key) {
          var splittedLanguages = language[0].replace('-', '_').split('_');
          if (splittedLanguages.length === 1) {
            // fr => fr_FR
        	  options.key = splittedLanguages[0].toLowerCase() + '_' + splittedLanguages[0].toUpperCase();
          } else if (splittedLanguages.length === 2) {
            // fr_fr => fr_FR
        	  options.key = splittedLanguages[0].toLowerCase() + '_' + splittedLanguages[1].toUpperCase();
          }
        }

        FIREBASE.get('i18n', options.key, function(data){
            if(deferred){
              
              deferred.resolve(data);
              deferred = null;
            }
        }, function(err){
            if(deferred){
              deferred.reject(options.key);
              //deferred = null;
            }
        });   

        $http({
          url: [
            options.prefix,
            options.key,
            options.suffix
          ].join(''),
          method: 'GET',
          params: ''
        }).then(function (data) {
          if(deferred){
            deferred.resolve(data.data.data);
            deferred = null;
          }
        }).catch(function (data) {
          if(deferred){
            deferred.reject(options.key);
          }
        });
                
        return deferred.promise;
      };
    }
]).config(function($provide) {
    $provide.decorator('$translate', function($delegate) {
        var _preferredLanguage = $delegate.preferredLanguage;

        $delegate.preferredLanguage = function() {
          var guessed = _preferredLanguage();

          // ensure that $preferredLanguage looks like fr_FR or fr_fr [Safari], and not "fr-fr" of just "fr", ...
          var language = guessed.match(/^[a-z]{2}([-_][a-zA-Z]{2})?$/);
          if (language !== null && language[0] === guessed) {
            var splittedLanguages = language[0].replace('-', '_').split('_');
            if (splittedLanguages.length === 1) {
              // fr => fr_FR
              return splittedLanguages[0].toLowerCase() + '_' + splittedLanguages[0].toUpperCase();
            } else if (splittedLanguages.length === 2) {
              // fr_fr => fr_FR
              return splittedLanguages[0].toLowerCase() + '_' + splittedLanguages[1].toUpperCase();
            }
          }

          return guessed;
        };

        return $delegate;
      });
    }).config(['cfpLoadingBarProvider', function(cfpLoadingBarProvider) {
    cfpLoadingBarProvider.includeBar = true;
    cfpLoadingBarProvider.includeSpinner = false;
    cfpLoadingBarProvider.latencyThreshold = 500;
    cfpLoadingBarProvider.parentSelector = '.wrapper > section';
}]).config(function(RestangularProvider) {
      RestangularProvider.setDefaultHttpFields({withCredentials: true})
      RestangularProvider.setBaseUrl(CONFIG.baseUrl);
      RestangularProvider.setFullRequestInterceptor(function(element, operation, what, url, headers, params) {
        L.log('Request', element, operation, what, url, headers, params)
        //  if(window.location.host.indexOf('localhost')>=0){
        //    headers = Object.assign(headers, { Authorization: 'APP ' + window.localStorage.getItem('session') })
        //}
        let token = FIREBASE.token || ''
        if(token){
          headers = Object.assign(headers, { Authorization: 'Bearer ' + token })
        }
        return {headers:headers, params: _.extend(params, {_t: new Date().getTime()} ), element: element};
	     });
	    RestangularProvider.setResponseExtractor(function(data, operation, what, url, response, deferred) {
	      var d;
        if (operation === "getList") {
	        d = data.data || [];
	        d.cursor = data.cursor;
          d.queryRL = data.queryRL;
          d.count = data.count;
          d.fromQ = data.fromQ;
	      } else {
	        d = data;
	      }
        //if(response.headers('x-aqrate-jwt')){ d.jwt = response.headers('x-aqrate-jwt') }
        if(response.headers('authorization')){ d.jwt = response.headers('authorization').replace('Bearer ','') }
	      return d;
	    });
        RestangularProvider.setRequestInterceptor(function(elem, operation) {
          if (operation === "remove") {
             return undefined;
          }
          return elem;
        });
})
//.config(['$compileProvider', function ($compileProvider) {
//  $compileProvider.debugInfoEnabled(false);
//}])
.factory('CloudStorageRestangular', function(Restangular){
		  return Restangular.withConfig(function(RestangularConfigurer){
			  RestangularConfigurer.setBaseUrl('https://storage.cloud.google.com');

		  });
})
.factory('LocalRestangular', function(Restangular){
  return Restangular.withConfig(function(RestangularConfigurer){
    RestangularConfigurer.setBaseUrl('https://local.aqrate.biz/api');
    RestangularConfigurer.setFullRequestInterceptor(function(element, operation, what, url, headers, params) {
      L.log('LocalRequest', element, operation, what, url, headers, params)
      headers = Object.assign(headers, { 'X-ProjectId': CONFIG.firebaseConfig.projectId, 'Authorization': '' })
      return {headers:headers, params: params, element: element};
     });
  });
})
.controller('NullController', function() {});
